import { CampaignType, useEngagementCampaignReportSummaryQuery } from '@anytag/graphql';
import { getValuableVariables } from '@anytag/shared-utils';
import {
  PostReportProvider,
  usePostReportFilter,
  EngagementReportGrid,
  EngagementReportTable,
  EngagementReportFilter,
  EngagementReportSummary
} from '@anytag/shared-organisms';
import { PostReportMode } from '@anytag/shared-types';
import { useEngagementDetailsContext } from '../engagement-details-context';

export const EngagementReport = () => {
  const { engagement, isOnlyTikTokTtcm, hasTrackingTune, hasTrackingReferral } = useEngagementDetailsContext();

  const { filter, setFilter, state } = usePostReportFilter();
  const { data, previousData, loading } = useEngagementCampaignReportSummaryQuery({
    variables: getValuableVariables({
      keyword: filter.keyword,
      endDate: filter.endDate,
      campaignId: engagement.id,
      startDate: filter.startDate
    })
  });

  const result = loading ? previousData : data;
  const summaryData = result?.engagementCampaignReportSummary || undefined;
  const isGridMode = filter.mode === PostReportMode.GRID;

  return (
    <PostReportProvider
      value={{
        isOnlyTikTokTtcm,
        campaignType: CampaignType.ENGAGEMENT,
        hasTracking: hasTrackingTune || hasTrackingReferral
      }}
    >
      <EngagementReportFilter
        filter={filter}
        segmentState={state}
        setFilter={setFilter}
        engagement={engagement}
        defaultColumnsForDownload={
          // we will set default Table fields https://anymindgroup.atlassian.net/browse/AT-7644
          isGridMode ? ['cost', 'followers', 'engagement', 'engagementRate', 'like', 'comment'] : undefined
        }
      />

      <EngagementReportSummary data={summaryData} engagement={engagement} />

      {isGridMode ? (
        <EngagementReportGrid engagement={engagement} />
      ) : (
        <EngagementReportTable engagement={engagement} summaryData={summaryData} />
      )}
    </PostReportProvider>
  );
};
